import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {COLORS, SIZES} from '@fupa/fupa-uikit';
import {Chip} from '@mui/material';
import {useSelector} from 'react-redux';
import {selectCollapsedAppBar} from 'app/hooks/reduxCreateSelectorHooks';

const COLLAPSED_HEIGHT = 82;
const EXPANDED_HEIGHT = 154;

const Wrapper = styled.div`
  position: fixed;
  top: ${props => (props.collapsed ? COLLAPSED_HEIGHT + 'px' : EXPANDED_HEIGHT + 'px')};
  display: flex;
  width: 100%;
  max-width: ${props => props.theme.desktopContentWidth}px;
  justify-content: center;
  z-index: 5;
  margin-top: ${SIZES[8]};
  transition: top 0.3s;
  ${props => props.theme.desktopLayout`
  top: ${EXPANDED_HEIGHT}px;
`};
`;

export const BackToStartButton = () => {
  const [show, setShow] = useState(false);

  const collapsedAppBar = useSelector(selectCollapsedAppBar);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > window.innerHeight) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    document.addEventListener('scroll', onScroll, {passive: true});

    return () => document.removeEventListener('scroll', onScroll, {passive: true});
  }, []);

  if (!show) {
    return null;
  }

  const backToStart = () => {
    // smoothly scroll to top of viewport
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  return (
    <Wrapper collapsed={collapsedAppBar}>
      <Chip
        sx={{
          backgroundColor: COLORS.darkestGrey,
          color: COLORS.white,
          zIndex: 10,
          opacity: 0.8,
          '&:hover': {
            backgroundColor: COLORS.darkestGrey,
            opacity: 1,
          },
        }}
        onClick={backToStart}
        label='Zum Anfang zurück'
      />
    </Wrapper>
  );
};
